import React from "react";
import spriteUrl from "./sprite.svg";

type IconProps = React.ComponentPropsWithRef<"svg"> & {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
};

export default function Icon({
  name,
  className,
  style,
  width = 24,
  height = 24,
  ...others
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      style={style}
      {...others}
    >
      <use href={`${spriteUrl}#${name}`}></use>
    </svg>
  );
}
